import store from '@/store'
import { getData } from '@core/utils/http/general'

export const datoFacturaInfo = idDatof => new Promise((resolve, reject) => {
  const ws = (store.state.cuenta.session.token) ? 'wsfactura' : 'wsinscripcion'
  const paramsRequest = {
    action: (!store.state.cuenta.session.token) ? 23 : 5,
    id_fact: idDatof,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, ws)
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

export const cursoInfo = idCurso => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 4,
    curso: idCurso,
    token: store.state.cuenta.session.token,
  }

  getData(paramsRequest, 'wscursos')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        const { curso, recursos, parciales } = response.data
        resolve({ curso, recursos, parciales })
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
